<template>
  <div class="root_page">
    <Nav></Nav>
    <router-view v-slot="{ Component }" class="page_router_content">
      <transition name="page-fade">
        <component :is="Component" :key="$route.path" />
      </transition>
    </router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import { Options, Vue } from "vue-class-component";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
require("./less/pc/common.less");

@Options({
  components: {
    Nav,
    Footer,
  },
  data() {
    return {};
  },
})
export default class App extends Vue {}
</script>

<style lang="scss">
@import url("./less/pc/page.less");

.root_page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page_router_content {
  width: 960px;
  background-color: #fff;
}

/* Page Transition - Fade in only (Apple/Google style) */
.page-fade-enter-active {
  transition: opacity 0.3s ease-out;
}

.page-fade-enter-from {
  opacity: 0;
}

.page-fade-leave-active {
  display: none; /* Instant leave to prevent layout shift */
}
</style>
